<div *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none">
  <!-- Navbar brand -->
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item">
      <a class="navbar-brand" [routerLink]="['/']">
        <span class="brand-logo">
          <img [src]="coreConfig?.app?.appLogoImage" alt="brand-logo" width="36" />
        </span>
        <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2>
      </a>
    </li>
  </ul>
  <!--/ Navbar brand -->
</div>

<div class="navbar-container d-flex content">
  <div class="bookmark-wrapper d-flex align-items-center">
    <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
    <ul class="nav navbar-nav d-xl-none">
      <li *ngIf="!coreConfig.layout.menu.hidden" class="nav-item d-flex flex-column justify-content-center">
        <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
          <span [data-feather]="'menu'" [class]="'ficon'"></span>
        </a>
      </li>
      <ng-container *ngIf="this.currentUser?.user?.role !== 'admin'">
        <li class="nav-item mx-1">
          <button (click)="gotoSection('nft')" type="button" class="btn btn-sm btn-outline-facebook nft-btn"
            [ngClass]="{'btn-facebook': getMenuStatus == 'nft'}" rippleEffect>
            <span [data-feather]="'image'"></span>
          </button>
        </li>
        <li class="nav-item">
          <button (click)="gotoSection('crypto')" type="button" class="btn btn-sm btn-outline-warning"
            [ngClass]="{'btn-warning': getMenuStatus == 'crypto'}" rippleEffect>
            <span [data-feather]="'layers'"></span>
          </button>
        </li>
        <li class="nav-item mx-1">
          <button (click)="gotoSection('stock')" type="button" class="btn btn-sm btn-outline-primary"
            [ngClass]="{'btn-primary': getMenuStatus == 'stock'}" rippleEffect>
            <span [data-feather]="'bar-chart-2'"></span>
          </button>
        </li>
      </ng-container>
    </ul>
    <!--/ Menu Toggler -->

    <!-- Bookmark -->
    <!-- <app-navbar-bookmark></app-navbar-bookmark> -->
    <!--/ Bookmark -->

    <!-- Logo -->
    <a [routerLink]="'/'" *ngIf="showIcon">
      <div fxLayout="row" fxLayoutAlign="center center">
        <img [src]="coreConfig?.app?.appLogoImage" width="36">
        <h2 class="ml-1 text-primary m-0">{{coreConfig.app.appName}}</h2>
      </div>
    </a>

    <ul class="nav navbar-nav d-none d-xl-flex" *ngIf="this.currentUser?.user?.role !== 'admin'">
      <!-- <li class="nav-item mx-1">
        <button (click)="gotoSection('nft')" type="button" class="btn btn-sm btn-outline-facebook nft-btn" [ngClass]="{'btn-facebook': getMenuStatus == 'nft'}" rippleEffect>
          <span [data-feather]="'image'" [class]="'mr-25'"></span> NFT</button>
      </li> -->
      <li class="nav-item">
        <button (click)="gotoSection('crypto')" type="button" class="btn btn-sm btn-outline-warning"
          [ngClass]="{'btn-warning': getMenuStatus == 'crypto'}" rippleEffect>
          <span [data-feather]="'layers'" [class]="'mr-25'"></span> Crypto
        </button>
      </li>
      <li class="nav-item mx-1">
        <button (click)="gotoSection('stock')" type="button" class="btn btn-sm btn-outline-primary"
          [ngClass]="{'btn-primary': getMenuStatus == 'stock'}" rippleEffect>
          <span [data-feather]="'bar-chart-2'" [class]="'mr-25'"></span> Stock
        </button>
      </li>
      <li class="nav-item border border-left"></li>
      <li class="nav-item mx-1">
        <button (click)="openAboutUsModal(aboutUs)" type="button" class="btn btn-sm btn-outline-primary" rippleEffect>
          <span [data-feather]="'aperture'" [class]="'mr-25'"></span> About Us
        </button>
      </li>
    </ul>

  </div>
  <ul class="nav navbar-nav align-items-center ml-auto">
    <!-- Language selection -->
    <!-- <li ngbDropdown class="nav-item dropdown dropdown-language">
      <a class="nav-link dropdown-toggle" id="dropdown-flag" ngbDropdownToggle>
        <i class="flag-icon flag-icon-{{ languageOptions[_translateService.currentLang].flag }}"></i
        ><span class="selected-language">{{ languageOptions[_translateService.currentLang].title }}</span></a
      >
      <div ngbDropdownMenu aria-labelledby="dropdown-flag">
        <a *ngFor="let lang of _translateService.getLangs()" ngbDropdownItem (click)="setLanguage(lang)">
          <i class="flag-icon flag-icon-{{ languageOptions[lang].flag }}"></i> {{ languageOptions[lang].title }}
        </a>
      </div>
    </li> -->
    <!--/ Language selection -->

    <!-- Toggle skin -->
    <li class="nav-item">
      <button type="button" placement="bottom" [ngbTooltip]="'Home'" [routerLink]="defaultRouting"
        class="nav-link nav-link-style btn">
        <span [data-feather]="'home'" class="ficon font-medium-5 feather"></span>
      </button>
    </li>
    <!-- <li class="nav-item">
      <button type="button" placement="bottom" [ngbTooltip]="'Help'" (click)="gotoHelp()" class="nav-link nav-link-style btn ml-md-1 ml-lg-0">
        <span [data-feather]="'help-circle'" class="ficon font-medium-5 feather"></span>
      </button>
    </li> -->
    <li class="nav-item d-none d-xl-block" *ngIf="!this.currentUser">
      <button type="button" placement="bottom" [ngbTooltip]="'Login / Registration'" (click)="openLoginModal()"
        class="btn btn-sm btn-primary">
        <span [data-feather]="'user'" class="mr-25 text-light"></span> Login / Signup
      </button>
    </li>
    <li class="nav-item d-block d-xl-none" *ngIf="!this.currentUser">
      <button type="button" placement="left" [ngbTooltip]="'Login / Registration'" (click)="openLoginModal()"
        class="btn nav-link nav-link-style ml-1 ml-lg-0">
        <span [data-feather]="'user'" class="ficon font-medium-5 feather"></span>
      </button>
    </li>
    <!--/ Toggle skin -->

    <!-- Search -->
    <!-- <app-navbar-search></app-navbar-search> -->
    <!--/ Search -->

    <!-- Cart -->
    <!-- <app-navbar-cart></app-navbar-cart> -->
    <!--/ Cart -->

    <!-- Notification -->
    <!-- <app-navbar-notification></app-navbar-notification> -->
    <!--/ Notification -->

    <!-- User Dropdown -->
    <li ngbDropdown class="nav-item dropdown-user" *ngIf="this.currentUser">
      <a class="nav-link dropdown-toggle dropdown-user-link" id="dropdown-user" ngbDropdownToggle
        id="navbarUserDropdown" aria-haspopup="true" aria-expanded="false">
        <div class="user-nav d-sm-flex d-none">
          <span class="user-name font-weight-bolder m-0">{{ this.currentUser?.user?.firstname | titlecase }} {{
            this.currentUser?.user?.lastname | titlecase }}</span>
          <!-- <span class="user-status">{{ this.currentUser?.user?.role }}</span> -->
        </div>
        <span class="avatar"><img class="round" [src]="avatarImage" alt="avatar" height="40" width="40" /><span
            class="avatar-status-online"></span></span>
      </a>
      <div ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-right">
        <a *ngIf="this.currentUser?.user" ngbDropdownItem [routerLink]="['/profile']"><span [data-feather]="'user'"
            [class]="'mr-50'"></span> Account</a>
        <a ngbDropdownItem href="mailto:hello@alphatrend.ai"><span [data-feather]="'mail'" [class]="'mr-50'"></span>
          Contact-Us</a>
        <a *ngIf="this.currentUser?.user" ngbDropdownItem [routerLink]="['/billing']"><span
            [data-feather]="'credit-card'" [class]="'mr-50'"></span> Billing</a>
        <a *ngIf="this.currentUser?.user" ngbDropdownItem [routerLink]="['/subscription']"><span
            [data-feather]="'refresh-cw'" [class]="'mr-50'"></span> Subscription</a>
        <div class="dropdown-divider"></div>
        <!-- <a ngbDropdownItem [routerLink]="['/pages/account-settings']"
          ><span [data-feather]="'settings'" [class]="'mr-50'"></span> Settings</a
        ><a ngbDropdownItem [routerLink]="['/pages/pricing']"
          ><span [data-feather]="'credit-card'" [class]="'mr-50'"></span> Pricing</a
        ><a ngbDropdownItem [routerLink]="['/pages/faq']"
          ><span [data-feather]="'help-circle'" [class]="'mr-50'"></span> FAQ</a
        > -->
        <a ngbDropdownItem (click)="logout()"><span [data-feather]="'power'" [class]="'mr-50'"></span> Logout</a>
      </div>
    </li>
    <!--/ User Dropdown -->
  </ul>
</div>
